import React from 'react';
import { CompassIcon, Building2Icon, TrophyIcon } from 'lucide-react';
const ProgramsSection = () => {
  const programs = [{
    tier: '1',
    title: 'Wealth Discovery Accelerator',
    description: 'Best for new investors or professionals with limited capital ready to grow.',
    features: ['INFASTRUCTURE', 'FUNDING', 'CAPITAL ACCELERATION'],
    buttonLabel: '$1000 Initial Investment'
  }, {
    tier: '2',
    title: 'Wealth Builder Blueprint',
    description: 'Best for entrepreneurs & investors with cashflow looking to build estate & legacy.',
    features: ['EVERYTHING IN TIER 1', 'ASSET PROTECTION', 'ASSET ACQUISITION'],
    buttonLabel: '$2500 Initial Investment'
  }, {
    tier: '3',
    title: 'Wealth Legacy Accelerator',
    description: 'Best for serious wealth builders ready to acquire profitable businesses/assets.',
    features: ['EVERYTHING IN TIER 1 & 2', 'PROFIT PROTECTION', 'EXPANSION & SUCCESSION'],
    buttonLabel: '$5000 Initial Investment'
  }];
  return <section id="programs" className="w-full py-16 sm:py-24 bg-cream-light" data-id="element-216">
      <div className="container mx-auto px-4" data-id="element-217">
        <div className="text-center mb-12 sm:mb-16" data-id="element-218">
          <h2 className="text-4xl font-bold section-title-decoration" data-id="element-219">
            Our <span className="text-gradient" data-id="element-220">Programs</span>
          </h2>
          <p className="text-center text-gray-700 max-w-4xl mx-auto mt-8 sm:mt-12 mb-12 sm:mb-16 text-lg" data-id="element-221">
            Choose the tier that aligns with your current financial journey and
            goals. Each program is designed to meet you where you are and take
            you where you want to go.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-222">
          {programs.map((program, index) => <div key={index} className="bg-white rounded-xl border border-gold-200 shadow-sm overflow-hidden flex flex-col" data-id="element-223">
              <div className="h-2 w-full bg-gradient-to-r from-gold-300 via-gold-400 to-gold-300" data-id="element-224" />

              <div className="flex justify-center py-6" data-id="element-225">
                <div className="rounded-full bg-gold-50 w-24 h-24 flex items-center justify-center border border-gold-200" data-id="element-226">
                  {program.tier === '1' && <CompassIcon className="w-12 h-12 text-gold-500" data-id="element-227" />}
                  {program.tier === '2' && <Building2Icon className="w-12 h-12 text-gold-500" data-id="element-228" />}
                  {program.tier === '3' && <TrophyIcon className="w-12 h-12 text-gold-500" data-id="element-229" />}
                </div>
              </div>

              <div className="px-6 text-center" data-id="element-230">
                <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-231">
                  {program.title}
                </h3>
                <p className="text-gray-600 mb-6" data-id="element-232">{program.description}</p>
              </div>

              <div className="px-8 space-y-4 mb-8" data-id="element-233">
                {program.features.map((feature, i) => <div key={i} className="flex items-start text-left" data-id="element-234">
                    <svg className="h-6 w-6 mr-3 text-gold-500 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor" stroke="none" data-id="element-235">
                      <path d="M20 6L9 17l-5-5 1.41-1.41L9 14.17l9.59-9.59L20 6z" data-id="element-236" />
                    </svg>
                    <span className="text-gray-700" data-id="element-237">{feature}</span>
                  </div>)}
              </div>

              <div className="px-6 pb-8 text-center mt-auto" data-id="element-238">
                <p className="text-2xl font-bold text-navy-900 mb-4" data-id="element-239">
                  {program.investment}
                </p>
                <button className="btn-gold rounded-md py-3 w-full text-base font-semibold text-white" data-id="element-240">
                  {program.buttonLabel}
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default ProgramsSection;